export default __webpack_public_path__ + "static/media/mp-1.6fde7fc4.png";